import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy `/estado` → `/status` (FE-15 §6). The host rule answers 301; this covers the SPA fallback. */
export const Route = createFileRoute("/estado")({
  beforeLoad: () => {
    throw redirect({ to: "/status", replace: true });
  },
});
